export const environment = {
  production: false,
  /** Google Analytics 4 Measurement ID (must match script in index.html). */
  googleAnalyticsId: 'G-B5CREGH67S' as string,
  apiBaseUrl: 'https://bodh.tanuh.ai/controlplane/',
  catalogueUiUrl: 'https://bodh.tanuh.ai/',
  email: 'info@tanuh.ai',
  hackathonSupportGmailComposeUrl:
    'https://mail.google.com/mail/?view=cm&fs=1&to=bodh%40tanuh.ai' as string,
  /** Recipient for contact form submissions (fallback when no action URL) */
  contactFormEmail: 'bodh@tanuh.ai',
  /** Zoho (or other) contact form POST action URL. Submit goes here via form POST. Set in env or here. */
  contactFormActionUrl:
    'https://forms.zohopublic.in/iudxcrm2/form/ContactUs/formperma/6K_gXLLX1rURl9Q7VEkbwY-sFVXgNXCQcfBu5iFGpyU/records' as string,
  /** API Explorer server base URL (overrides server from OpenAPI YAML). */
  apiExplorerServerUrl: 'https://bodh.tanuh.ai/',
  /** @deprecated Use contactFormActionUrl */
  contactFormApiUrl: '' as string | undefined,
  keycloak: {
    url: 'https://bodh.tanuh.ai/auth',
    realm: 'tanuh',
    clientId: 'angular-client',
  },

  // Api URLS
  basePathUrl: 'https://bodh.tanuh.ai/controlplane/',
  baseFilePathUrl: 'https://bodh.tanuh.ai/files-connect-api/',
  /** Client-side envelope encryption (KMS-wrapped DEK) for contribution dataset uploads */
  encryptedDatasetUpload: true,
  baseRsPathUrl: 'https://bodh.tanuh.ai/dataplane/',
  baseSandboxPathUrlCpu: 'https://bodh.tanuh.ai/sandbox-api/v1/',
  baseSandboxPathUrlGpu: 'https://bodh.tanuh.ai/sandbox-api/v1/',
  baseCommunityPathUrl: 'https://bodh.tanuh.ai/community/',
  dataReadinessS3Url:
    'https://data-readiness-prod.s3.cyfuture.cloud/data-readiness-prod/',
  baseChallengePathUrl: 'https://bodh.tanuh.ai/community/challenge',
  auditingApiPath: 'iudx/v2/auditing/',
  authApiPath: 'iudx/v2/auth/',
  catApiPath: 'iudx/v2/cat/',
  aclapdPath: 'iudx/acl/apd/v2/',
  leadershipApiPath: 'iudx/v2/leaderboard/',
  challengeEvaluatorBaseUrl:
    'https://bodh.tanuh.ai/challenge-evaluator-backend',
  benchmarkLeaderboardBaseUrl: 'https://bodh.tanuh.ai/leaderboard',
  /** Buffer TEE base URL for RA-TLS model onboarding (port 8443). */
  bufferTeeUrl: 'https://bodh.tanuh.ai/tee' as string,

  userApiPath: 'iudx/v2/auth/user/',
  userInteractionApiPath: 'iudx/v2/user',
  activitiesApiPath: 'iudx/v2/auditing/consumer/activity',

  rolesApiPath: 'iudx/v2/auth/roles',
  roleUpgradeApiPath: 'iudx/v2/auth/organization/user/provider_role/requests',

  ogcApiPath: 'https://bodh.tanuh.ai/geoserver/',
  api_ogc_server_domain: 'https://bodh.tanuh.ai/ogc-rs/',
  ngsiLdApiPath: 'https://bodh.tanuh.ai/dataplane-rs/',
  gatewayApiPath: 'https://bodh.tanuh.ai/dataplane/rsp/',

  userManualUrl:
    'https://data-readiness-prod.s3.cyfuture.cloud/user-manual/User%20Manual%20-%20NHA%20v1.0.pdf?domain=data-readiness-prod.s3.cyfuture.cloud',

  // important links
  importantLinks: {
    home: '/',
    provider: '/provider/home',
    consumer: '/consumer/home',
    canvas: '/canvas',
  },

  helpDeskUrl: 'https://bodh.tanuh.ai//help-desk',

  // API Documentation URLs (for footer links)
  apiDocsBaseUrl: 'https://bodh.tanuh.ai/apis',
  controlPlaneApiDocsUrl: 'https://bodh.tanuh.ai/controlplane/apis',
  fileServerApiDocsUrl: 'https://bodh.tanuh.ai/files-connect-api/apis',
  resourceServerApiDocsUrl: 'https://bodh.tanuh.ai/dataplane/apis',
  ogcServerApiDocsUrl: 'https://bodh.tanuh.ai/auth',
  sandboxServerApiDocsUrl: 'https://bodh.tanuh.ai/auth',
};
